import { Alert, Platform } from "react-native";

/**
 * Cross-platform alert with Cancel + Confirm buttons
 */
export function showConfirmAlert(
  title: string,
  message: string,
  onConfirm: () => void,
  onCancel?: () => void
) {
  if (Platform.OS === "web") {
    // Fallback for web: use window.confirm
    const confirmed = window.confirm(`${title}\n\n${message}`);
    if (confirmed) {
      onConfirm();
    } else {
      onCancel?.();
    }
  } else {
    // Native Alert
    Alert.alert(
      title,
      message,
      [
        {
          text: "Cancel",
          style: "cancel",
          onPress: onCancel,
        },
        {
          text: "Confirm",
          onPress: onConfirm,
        },
      ],
      { cancelable: true }
    );
  }
}